<template>
  <div style="width: 100%">
    <v-autocomplete
        v-model="value"
        :items="values"
        item-text="name"
        item-value="uid"
        :label="title"
        clearable
    ></v-autocomplete>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-ad-placement-dropdown",
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Ad Placement"),
    model: VueTypes.string
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return RedactorUtils.getAdPlacements();
    }
  }
}
</script>